const disableBodyScrolling = () => {
  const bodyStyle = document?.body?.style;
  if (bodyStyle && window) {
    const nextScrollPosition =
      bodyStyle.position === 'fixed' ? document.body.dataset.yScrollPositionBeforeDisable : window.scrollY;
    document.body.dataset.yScrollPositionBeforeDisable = `${nextScrollPosition}`;
    bodyStyle.top = `-${nextScrollPosition}px`;
    bodyStyle.overflowY = 'scroll';
    bodyStyle.position = 'fixed';
    bodyStyle.width = '100%';
  }
};

const enableBodyScrolling = () => {
  const bodyStyle = document?.body?.style;
  if (bodyStyle && window) {
    const stylePropertiesToRemove = ['overflow-y', 'position', 'top', 'width'];
    stylePropertiesToRemove.forEach((propName) => bodyStyle.removeProperty(propName));
    if (document.body.dataset.yScrollPositionBeforeDisable) {
      const prevScrollYPosition = parseInt(document.body.dataset.yScrollPositionBeforeDisable, 10);
      // A page-level `scroll-behavior: smooth` (XDP sets one globally) would animate this restore,
      // reading as a flash to the top and a scroll back down. Suppressed inline for the one write
      // rather than via `behavior: 'instant'`, which throws below the supported Safari baseline.
      const { scrollBehavior } = document.documentElement.style;
      document.documentElement.style.scrollBehavior = 'auto';
      window.scrollTo(0, prevScrollYPosition);
      document.documentElement.style.scrollBehavior = scrollBehavior;
    }
  }
};

export const disableScrolling = (shouldBeDisabled: boolean): void => {
  if (shouldBeDisabled) {
    disableBodyScrolling();
  } else {
    enableBodyScrolling();
  }
};
